import { render, staticRenderFns } from "./skeletonFilmDetail.vue?vue&type=template&id=698ab9f5&scoped=true&lang=true&"
import script from "./skeletonFilmDetail.vue?vue&type=script&lang=js&"
export * from "./skeletonFilmDetail.vue?vue&type=script&lang=js&"
import style0 from "./skeletonFilmDetail.vue?vue&type=style&index=0&id=698ab9f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698ab9f5",
  null
  
)

export default component.exports